export default __webpack_public_path__ + "d187825e1138d37f723fd0e3f7cdc78f.png";